import { FormControl, InputLabel, OutlinedInput, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import addGrayOutline from "../../../../assets/img/add-gray-outline.svg";
import Drawer from "../../../../components/Drawer";
import InputMask from "react-input-mask";

import "../Collaborators.scss";
import MultipleSelectChip from "../../../../components/inputs/MultipleSelectChip";
import MultipleCollaboratorsSelectChip from "../../../../components/inputs/MultipleSelectChip/MultipleCollaboratorsSelectChip";
import MultipleServicesSelectChip from "../../../../components/inputs/MultipleSelectChip/MultipleServicesSelectChip";
import MultipleDaysOfWeekSelectChip from "../../../../components/inputs/MultipleSelectChip/MultipleDaysOfWeekSelectChip";
import { useHistory } from "react-router-dom";
import api from "../../../../config/api";
import CircleImage from "../../../../components/Image/CircleImage";
import { useAuth } from "../../../../context/ContextApi";
import swal from "sweetalert";

export const CollaboratorDrawer = ({
  isOpen,
  setIsCollaboratorDrawerOpen,
  collaboratorToSubmit,
  handleServicesChange,
  handleDaysOfWeekChange,
  setCollaboratorToSubmit,
}) => {
  const history = useHistory();
  const { userToken, userEstablishment } = useAuth();
  const handleSubmitCollaborator = async (e) => {
    e.preventDefault();

    if (!collaboratorToSubmit.name) {
      return swal("Erro", "Digite um nome", "error");
    }
    if (!collaboratorToSubmit.services.length) {
      return swal("Erro", "Selecione um serviço", "error");
    }
    // TODO
    // console.log("collaboratorToSubmit");
    // console.log(collaboratorToSubmit);
    const dataup = new FormData();
    const config = {
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": `multipart/form-data`,
      },
    };

    dataup.append("file", collaboratorToSubmit.file);
    dataup.append("name", collaboratorToSubmit.name);
    dataup.append(
      "services",
      collaboratorToSubmit.services.map((service) => service._id)
    );
    dataup.append("establishment", userEstablishment);
    try {
      const { data } = await api.post("/professional", dataup, config);
      // console.log(data.professional);
      history.replace("/colaboradores/" + data.professional._id);
    } catch (e) {
      console.error("CollaboratorDrawer, handleSubmitCollaborator", e);
    } finally {
    }
  };

  const selectImageNewUser = (e) => {
    // console.log("selecting new user image");
    if ((e !== undefined) & (e !== null)) {
      if (e.target.files && e.target.files[0]) {
        setCollaboratorToSubmit((values) => ({
          ...values,
          avatar: URL.createObjectURL(e.target.files[0]),
          file: e.target.files[0],
        }));
      }
    }
  };
  // function handleSelecetedTags(items) {
  //   console.log(items);
  // }

  return (
    <Drawer
      className="d-flex flex-column justify-content-between"
      show={isOpen}
      onClose={() => setIsCollaboratorDrawerOpen(false)}
    >
      <form onSubmit={handleSubmitCollaborator}>
        <div className="d-flex flex-column h-100">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-3 d-block">Foto do colaborador</span>
          <label className="d-flex justify-content-center align-self-start flex-column c-pointer mb-3">
            {collaboratorToSubmit?.avatar ? (
              <CircleImage url={collaboratorToSubmit?.avatar} sizePx="80px" />
            ) : (
              <img src={addGrayOutline} className=" add-collaborator-image-button" alt="" />
            )}

            <input type="file" id="file" name="photo" onChange={(e) => selectImageNewUser(e)} className="d-none" />
          </label>

          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 d-block">Informações gerais</span>
          <TextField
            onChange={(event) =>
              setCollaboratorToSubmit((collaboratorToSubmit) => ({ ...collaboratorToSubmit, name: event.target.value }))
            }
            defaultValue={collaboratorToSubmit?.name}
            required
            name="name"
            label={"Nome do profissional"}
            variant={"outlined"}
            // error={erroName}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <MultipleServicesSelectChip
            values={collaboratorToSubmit?.services}
            label="Serviços realizados pelo profissional *"
            handleCollaboratorServicesChange={handleServicesChange}
          />
        </div>
        <div className=" col-12 d-flex justify-content-end  add-collaborator-drawer-footer ">
          <button
            type="button"
            onClick={() => setIsCollaboratorDrawerOpen(false)}
            className="btn button-white-primary br-6 border-auro-metal me-3 px-4"
          >
            Cancelar
          </button>
          <button type="submit" className="btn br-6 bg-gradient-theme-blue text-white px-4">
            Salvar
          </button>
        </div>
      </form>
    </Drawer>
  );
};
